// extracted by mini-css-extract-plugin
export default {"contentHeader":"MasterDetailOrderGrid_contentHeader__hBI+2","tradeHistory":"MasterDetailOrderGrid_tradeHistory__F8jXA","orderHistory":"MasterDetailOrderGrid_orderHistory__JNnvn"};